import { useEffect, useState } from "react";
import { readEncryptedJsonResponse } from "../common/readEncryptedJsonResponse";
import { useParams } from "react-router";
import { NavLink } from "react-router-dom";
import { scrollToContentBottom } from "../common/helper";

function MarketJodiChart() {
    const [data, setData] = useState([]);
    const params = useParams();
    const RED = ['00','05','11','16','22','27','33','38','44','49','50','55','61','66','72','77','83','88','94','99'];

    useEffect(() => {
        // Scroll to top when component mounts or params change
        window.scrollTo({ top: 0, behavior: 'smooth' });
        // Reset data when params change
        setData({});
        fetchData();
    }, [params.id]);

    useEffect(() => {
        if (Object.keys(data).length > 0 && window.location.search.includes("scrollToBottom=true")) {
            scrollToContentBottom();
        }
    },[data]);

    const fetchData = async () => {
        if (!params.id) return;
        
        const host = process.env.REACT_APP_API_HOST;

        fetch(host + '/api/market-insights', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ id: params.id, type: 'jodi' })
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to fetch data');
                }
                return readEncryptedJsonResponse(response);
            })
            .then((data) => {
                setData(data);
            })
            .catch((error) => {
                console.log("Error => ", error)
                setData({});
                // You can also display a user-friendly error message here
            });
    }

    return (
        <main className="container chart-wrapper">
            <h1 className="h2"> {params.id} Jodi Chart </h1>
            <p className="desc"> {params.id} Jodi Chart Satta Matka Record Old History Historical Data Bracket Results Chart Online Live Book Digits Numbers</p>

            <div className="scroll-down-button-wrapper">
                <button className="button__wrapper" onClick={scrollToContentBottom} id="scroll-down-button">Scroll Down</button>
            </div>

            <div className="table-responsive d-flex justify-content-center align-items-center">
                <table className="table w-75" border="collapse">
                    <thead>
                        <tr>
                            <th className="ch">MON</th>
                            <th className="ch">TUE</th>
                            <th className="ch">WED</th>
                            <th className="ch">THU</th>
                            <th className="ch">FRI</th>
                            <th className="ch">SAT</th>
                            <th className="ch">SUN</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            Object.entries(data).map(([dateRange, days], i) => {
                                return <tr key={i}>
                                    {
                                        days.map((d, _i) => {
                                            return <td className="cc" key={_i}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        alignItems: "center",
                                                        color: RED.includes(d.r) ? "red" : "black"
                                                    }}
                                                >
                                                    <span className="cp"> {d.r} </span>
                                                </div>
                                            </td>
                                        })
                                    }
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>


            <div className="charts-btb-blk">
                <div className="back-btn">
                    <NavLink 
                        to={'/charts'}
                    >
                        <button className="button__wrapper chart__btn">Back</button>
                    </NavLink>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                    <button className="button__wrapper chart__btn" id="scroll-top-button"
                        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    >
                        Scroll to Top
                    </button>
                </div>
            </div>

        </main>

    );
}


export default MarketJodiChart;